import axiosInstance from '../lib/api/axiosInstance';
import { 
  SSPFilters, 
  SSPDataResponse, 
  SSPFilterOptions 
} from '../types/ssp';

// Récupérer les données du dashboard SSP
export const getSSPDashboardData = async (filters?: SSPFilters): Promise<SSPDataResponse> => {
  try {
    // Construire les paramètres de requête
    const params = new URLSearchParams();
    
    if (filters?.site) {
      if (Array.isArray(filters.site)) {
        // Ajouter chaque site comme paramètre séparé
        filters.site.forEach(site => {
          params.append('site', site);
        });
      } else {
        params.append('site', filters.site);
      }
    }
    
    if (filters?.startDate) {
      params.append('startDate', filters.startDate);
    }
    
    if (filters?.endDate) {
      params.append('endDate', filters.endDate);
    }

    const queryString = params.toString();
    const url = `/ssp/dashboard${queryString ? `?${queryString}` : ''}`;
    
    const response = await axiosInstance.get<SSPDataResponse>(url);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching SSP dashboard data:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch SSP dashboard data');
  }
};

// Récupérer les options de filtres SSP
export const getSSPFilterOptions = async (): Promise<SSPFilterOptions> => {
  try {
    const response = await axiosInstance.get<SSPFilterOptions>('/ssp/filters');
    return response.data;
  } catch (error: any) {
    console.error('Error fetching SSP filter options:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch SSP filter options');
  }
};